import Fuse from 'fuse.js';

import { AutocompleteItem } from 'src/general/components/Autocomplete/Autocomplete.types';
import { DisplayMode } from 'src/stores/filterSidebarStore';

import { FilterHierarchyFieldsGroupOption, FilterItemProps, FilterOption } from '../../PlpFilters.type';
import { PlpFiltersMakeLabelSelected } from './PlpFiltersMakeLabelSelected';

type SearchItem = AutocompleteItem<string> & {
  keyword: string;
  typeLabel: 'Make' | 'Model';
} & FilterHierarchyFieldsGroupOption;

export const getFilteredOptions = (options: FilterHierarchyFieldsGroupOption[], displayMode: DisplayMode) => {
  if (displayMode === 'popular') {
    return options.slice(0, 8);
  }

  return options.filter((option) => option.children!.length > 1).sort((a, b) => a.value.localeCompare(b.value));
};

export const flattenOptions = (options: FilterHierarchyFieldsGroupOption[], currentFilters: FilterOption[]) => {
  const flattenedOptions: FilterItemProps[] = [];

  if (currentFilters.length) {
    options.forEach((make) => {
      if (currentFilters.some((filter) => filter.value === make.value)) {
        flattenedOptions.push({
          ...make,
          label: <PlpFiltersMakeLabelSelected label={make.label} typeLabel="Make" />,
        });
      }

      flattenChildOptions(make, flattenedOptions, currentFilters);
    });
  }
  return flattenedOptions.sort((a, b) => (a.value < b.value ? -1 : 1));
};

const flattenChildOptions = (
  make: FilterHierarchyFieldsGroupOption,
  flattenedOptions: FilterItemProps[],
  currentFilters: FilterOption[],
) => {
  if (make.children?.length) {
    make.children.forEach((model) => {
      if (currentFilters.some((filter) => filter.value === model.value && model.value !== make.value)) {
        flattenedOptions.push({
          ...model,
          label: <PlpFiltersMakeLabelSelected label={`${make.labelNoCount} ${model.label}`} typeLabel="Model" />,
        });
      }
    });
  }
};

export const generateFuseIndex = (options: FilterHierarchyFieldsGroupOption[]) => {
  const collection: SearchItem[] = [];

  options.forEach((make) => {
    collection.push({
      ...make,
      key: make.value,
      label: `${make.label}`,
      keyword: `${make.labelNoCount}`,
      typeLabel: 'Make',
    });

    make.children?.forEach((model) => {
      // Skip the "All option"
      if (make.value !== model.value) {
        collection.push({
          ...model,
          key: model.value,
          label: `${make.labelNoCount} ${model.label}`,
          value: model.value,
          keyword: `${make.labelNoCount} ${model.labelNoCount}`,
          typeLabel: 'Model',
        });
      }
    });
  });

  const fuseOptions: Fuse.IFuseOptions<SearchItem> = {
    includeMatches: true,
    includeScore: true,
    threshold: 0.45,
    ignoreLocation: true,
    keys: ['keyword'],
  };
  const fuse = new Fuse<SearchItem>(collection, fuseOptions);
  return fuse;
};
